module.exports = __webpack_public_path__ + "static/media/chevron-up.fae4fb51.svg";